import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Profile from './pages/Profile'
import Test from './pages/Test'
import PrivateRoutes from './utils/PrivateRoutes'
import ImageGeneration from './pages/ImageGeneration'

function App() {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route element={<PrivateRoutes />}>
                {/* <Route element={<Home/>} path="/" exact/> */}
                <Route element={<Profile/>} path="/profile"/>
            </Route>
            <Route element={<Test/>} path="/" exact/>
            <Route element={<Home/>} path="/home"/>
            <Route element={<ImageGeneration/>} path="/images"/>
          </Routes>
      </Router>
    </div>
  );
}

export default App;